import { render, staticRenderFns } from "./TextLayer.vue?vue&type=template&id=22c68eaa&scoped=true"
import script from "./TextLayer.vue?vue&type=script&lang=js"
export * from "./TextLayer.vue?vue&type=script&lang=js"
import style0 from "./TextLayer.vue?vue&type=style&index=0&id=22c68eaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c68eaa",
  null
  
)

export default component.exports